<template>
    <div class="spinnerLoading">
      <p>
        <b-icon icon="laptop" font-scale="5"></b-icon
        ><b-icon icon="three-dots" animation="cylon" font-scale="5"></b-icon
        ><b-icon icon="cloud" font-scale="5"></b-icon>
      </p>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>